<button mat-flat-button 
  [color]="color"
  [disabled]="disabled"
  [class.full-width]="fullWidth">
  <ng-content></ng-content>
</button>